import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';
import { showTokenTransactionPopup, showTrxTransactionPopup } from '@/core/presenter/controller/PopupController';
import { useCallback } from 'react';

interface IProps {
  activity: ViewModel.IResponseActivity;
}

const ActivityItem = ({ activity }: IProps): JSX.Element => {
  const handleClickActivityItem = useCallback(() => {
    if (activity.coinType === ViewModel.AssetType.TOKEN) showTokenTransactionPopup(activity);
    else showTrxTransactionPopup(activity);
  }, [activity]);

  const handleCopyClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    // 이벤트 전파 방지
    e.preventDefault();
    e.stopPropagation();

    const text = activity.type === '보내기' ? activity.to : activity.from;
    navigator.clipboard.writeText(text);
  };

  const isSend = activity.type === '보내기';
  const memo = isSend ? activity.to_memo : activity.from_memo;



  return (
    <div className="activity-item" data-type={activity.type} onClick={handleClickActivityItem}>
      <p className="activity-date text-sm font-normal">{activity.date}</p>
      
      <div className="activity-row">
        <div className="activity-left">
          <div className={clsx('activity-icon-wrapper', { send: isSend, receive: !isSend })}>
            <img 
              src={`./images/${isSend ? 'send' : 'receive'}-icon.png`} 
              alt={activity.type} 
              className="activity-icon" 
            />
            <span className="activity-coin-badge text-xs font-normal">{activity.coinType}</span>
          </div>
          <div className="activity-main">
            <div className="activity-type-row">
              <span className="activity-type text-sm font-semibold">{activity.type}</span>
              <span
                className={clsx('activity-status text-sm font-medium', {
                  success: activity.status === '성공',
                  fail: activity.status === '실패',
                })}
              >
                {activity.status}
              </span>
            </div>
          </div>
        </div>
        
        <div className="activity-center">
          <div className="activity-address-row">
            <span className="text-xs font-normal">
              {isSend ? '→' : '←'} {isSend ? activity.to_short : activity.from_short}
            </span>
            <button type="button" className="copy-btn-small" onClick={handleCopyClick}>
              <img src="./images/copy-icon.png" alt="복사" className="copy-icon-small" />
            </button>
          </div>
          {memo && <p className="activity-memo text-sm font-normal">{memo}</p>}
        </div>
        
        <div className="activity-right">
          <p className="amount-value text-base font-semibold"> {activity.amount}</p>
          <p className="amount-krw text-sm font-normal">{activity.krwAmount}</p>
        </div>
      </div>
    </div>
  );
};

export default ActivityItem;
